import React, { useCallback, useEffect, useMemo } from "react";
import styled from "styled-components";
import { SummaryPanel, Card } from "./Card";

export class Ghost {
  constructor(name, symptoms, additionalInfo) {
    this.name = name;
    this.symptoms = symptoms;
    this.additionalInfo = additionalInfo;
  }
}
export function GhostSuggestions({
  selectedEvidence,
  onSuggestionsChanged,
  ruledOutEvidence,
}) {
  // "EMF Level 5",
  //   "Ghost Orbs",
  //   "Ghost Writing",
  //   "Freezing Temperatures",
  //   "Spirit Box",
  //   "Fingerprints",
  const AllGhosts = useMemo(
    () => [
      new Ghost(
        "Goryo",
        ["EMF Level 5", "D.O.T.S Projector", "Fingerprints"],
        "Using a video camera is the only way to view a Goryo, when it passes through a DOTS projector. Unique Strengths: A Goryo will usually only show itself on camera if there are no people nearby. Weaknesses: They are rarely seen far from their place of death."
      ),
      new Ghost(
        "Myling",
        ["EMF Level 5", "Ghost Writing", "Fingerprints"],
        "A Myling is a very vocal and active ghost. They are rumoured to be quiet when hunting their prey. Unique Strengths: A Myling is known to be quieter when hunting. Weaknesses: Mylings more frequently make paranormal sounds."
      ),
      new Ghost(
        "Hantu",
        ["Freezing Temperatures", "Ghost Orbs", "Fingerprints"],
        "A rare ghost that can be found in hot climates. They are known to attack more often in cold weather. Their speed is fully based on the temperature of the rooms it goes through, moving faster in colder areas, and slower in warmer areas."
      ),
      new Ghost(
        "Yokai",
        ["Spirit Box", "Ghost Orbs", "D.O.T.S Projector"],
        "A common type of ghost that is attracted to human voices. They can usually be found haunting family homes. It has been known to become aggressive towards the players, that being too loud near the ghost."
      ),
      new Ghost(
        "Shade",
        ["Freezing Temperatures", "EMF Level 5", "Ghost Writing"],
        "Shades are a typically shy, and will decrease their activity in the presence of an audience. This can make them hard to locate when traveling in groups. Don't confuse their shyness with friendlyness as they often will attack lone victims. Travel with other for increased safety."
      ),
      new Ghost(
        "Phantom",
        ["Spirit Box", "Fingerprints", "D.O.T.S Projector"],
        "Phantoms can be summoned via the Ouija board. Looking at one will cause an extreme reduction in sanity. Snapping a picture of a phantom will force it to disappear for a moment."
      ),
      new Ghost(
        "Jinn",
        ["Freezing Temperatures", "EMF Level 5", "Fingerprints"],
        "Jinn are one of the fastest ghosts you can find, so be sure to stay near potential hiding spots when available. When they near a victim they will slow down to match the speed of their prey. The power source of their home amplifies their hunting power so turning it off may increase your likelihood of survival."
      ),
      new Ghost(
        "Yurei",
        ["Ghost Orbs", "D.O.T.S Projector", "Freezing Temperatures"],
        "Yurei are ghosts feeding from emotions of revenge and jealousy. These emotions feed into their violent tendencies. Seeing one will cause a significant reduction in sanity. Smudge sticks may be used to prevent Yurei from wandering around their location."
      ),
      new Ghost(
        "Mare",
        ["Ghost Orbs", "Ghost Writing", "Spirit Box"],
        "The Mare is known to many as the bringer of nightmares. They thrive in dark environments so turning on lights will increase your chances of survival."
      ),
      new Ghost(
        "Demon",
        ["Ghost Writing", "Freezing Temperatures", "Fingerprints"],
        "Demons are likely the most dangerous ghost you will enounter. Their bloodlust leads to very frequent attacks to vicitms in their vicinity. They however can be communicated with via a ouija board without causing a reduction in sanity. Just be advised it may cause them to retaliate."
      ),
      new Ghost(
        "Banshee",
        ["Ghost Orbs", "D.O.T.S Projector", "Fingerprints"],
        "Banshees are very predatorial ghosts which tend to choose one victim to seek out until it can make its kill. They greatly fear the presence of a crusifix in a room and are less likely to attack when one is nearby"
      ),
      new Ghost(
        "Revenant",
        ["Freezing Temperatures", "Ghost Writing", "Ghost Orbs"],
        "Revenants are vicious killers who attack any and all who come near. Similar to Jinn they have been known to travel at high speeds when hunting, but unlike the Jinn, will only increase speed when they have located their victim of choice. Hiding during the hunt will prevent their fierce speeds."
      ),
      new Ghost(
        "Oni",
        ["Freezing Temperatures", "EMF Level 5", "D.O.T.S Projector"],
        "Oni are closely related to demons, and as such are powerful hunters. They are known to become increasingly aggressive and active when near any number of people. They often throw objects with great strength. These qualities make them easy to locate by roaming around"
      ),
      new Ghost(
        "Poltergeist",
        ["Ghost Writing", "Spirit Box", "Fingerprints"],
        "Poltergeists are very active ghosts that tend to make their presence known by making noises as well as throwing physical object. They can even throw several objects at once. Observing their phyisical manifestations into the world will decrease your sanity. For this reason they are weaker when in area that have less objects which can be thrown."
      ),
      new Ghost(
        "Spirit",
        ["EMF Level 5", "Spirit Box", "Ghost Writing"],
        "The most common ghost you are likely to find. They can be extremely dangerous, as they tend to linger in the area of their untimely death. Smudge sticks can be used to prevent attacks by a spirit for a considerable amount of time."
      ),
      new Ghost(
        "Wraith",
        ["EMF Level 5", "Spirit Box", "D.O.T.S Projector"],
        "Wraiths are very dangerous, having the ability to fly and travel through walls. Since they tend to fly you may have a hard time tracking footsteps, but they are however week to salt and will avoid it where placed. Wraiths may posses electronics and use them as bait."
      ),
    ],
    []
  );
  const selectedEvidenceMatchesSymptoms = useCallback(
    (symptoms) => {
      const matchingSymptoms = selectedEvidence.filter((evidence) =>
        symptoms.includes(evidence)
      );
      return matchingSymptoms.length === selectedEvidence.length;
    },
    [selectedEvidence]
  );
  const ruledOutEvidenceMatchesSymptoms = useCallback(
    (symptoms) => {
      const matchingSymptoms = ruledOutEvidence.filter((evidence) =>
        symptoms.includes(evidence)
      );
      return matchingSymptoms.length !== 0;
    },
    [ruledOutEvidence]
  );
  const getRemainingEvidence = (symptoms) => {
    const remainingEvidence = symptoms.filter(
      (symptoms) => !selectedEvidence.includes(symptoms)
    );
    return remainingEvidence.length
      ? "Remaining: " + remainingEvidence.join(", ")
      : "";
  };
  const eligibleGhosts = useMemo(
    () =>
      AllGhosts.filter(
        (ghost) =>
          selectedEvidenceMatchesSymptoms(ghost.symptoms) &&
          !ruledOutEvidenceMatchesSymptoms(ghost.symptoms)
      ),
    [
      AllGhosts,
      selectedEvidenceMatchesSymptoms,
      ruledOutEvidenceMatchesSymptoms,
    ]
  );
  const simpleMode = eligibleGhosts.length > 4;
  const headerText =
    eligibleGhosts.length > 1 ? "Possible ghosts:" : "Ghost found:";
  const onChanged = useCallback(() => {
    onSuggestionsChanged(eligibleGhosts);
  }, [onSuggestionsChanged, eligibleGhosts]);
  useEffect(() => {
    onChanged();
  }, [selectedEvidence, onChanged, ruledOutEvidence]);
  if (eligibleGhosts.length === AllGhosts.length) {
    return <React.Fragment></React.Fragment>;
  }
  return (
    <SuggestionsPanel>
      {eligibleGhosts.length > 0 && (
        <React.Fragment>
          <HeaderLayout>
            <SuggestionHeader>{headerText}</SuggestionHeader>
          </HeaderLayout>
          {eligibleGhosts.map((ghost, i) => {
            return (
              <GhostSummary
                key={i}
                ghost={ghost}
                simpleSummary={simpleMode}
                remainingEvidence={getRemainingEvidence(ghost.symptoms)}
              ></GhostSummary>
            );
          })}
        </React.Fragment>
      )}
      {eligibleGhosts.length === 0 && (
        <React.Fragment>
          You've discovered a new type of ghost...
          <div>Maybe you should check your evidence again.</div>
        </React.Fragment>
      )}
    </SuggestionsPanel>
  );
}
export function GhostSummary({ ghost, simpleSummary, remainingEvidence }) {
  return (
    <SummaryPanel>
      <div>
        {!simpleSummary && (
          <Card
            header={ghost.name}
            summary={ghost.additionalInfo}
            subHeader={remainingEvidence}
          ></Card>
        )}
        {simpleSummary && (
          <ShortCard>
            {ghost.name} <SmallText>{remainingEvidence}</SmallText>
          </ShortCard>
        )}
      </div>
    </SummaryPanel>
  );
}
const SmallText = styled.span`
  margin-left: 50px;
  font-size: 12px;
  margin-top: auto;
  margin-bottom: auto;
`;
const ShortCard = styled.div`
  margin-left: 30px;
  display: flex;
  overflow: hidden;
`;
const SuggestionHeader = styled.div`
  font-size: 24px;
  @media (max-width: 750px) {
    font-size: 16px;
  }
  margin-left: 25px;
  margin-right: auto;
`;
const HeaderLayout = styled.div`
  display: flex;
`;
const SuggestionsPanel = styled.div`
  width: 100%;
  min-width: 100%;
`;
